import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface KeyValueItem {
  label: ReactNode
  value: ReactNode
  /** Monospace value: ids, codes, URLs. */
  mono?: boolean
}

/** Label / value pairs. Two columns side by side; stacked on a narrow screen
 *  when `stack` is set. */
export function KeyValue({ items, stack, className }: { items: KeyValueItem[]; stack?: boolean; className?: string }) {
  return (
    <dl
      className={cn(
        'grid gap-x-4 gap-y-2 text-table',
        stack ? 'grid-cols-1 sm:grid-cols-[max-content_1fr]' : 'grid-cols-[max-content_1fr]',
        className,
      )}
    >
      {items.map((it, i) => (
        <div key={i} className="contents">
          <dt className="text-muted-foreground">{it.label}</dt>
          <dd className={cn('min-w-0 break-words', it.mono && 'font-mono text-meta', stack && 'mb-1 sm:mb-0')}>
            {it.value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
